import { render } from "./TheRekionAdminMenuHeader.vue?vue&type=template&id=1f7e907c&scoped=true&ts=true"
import script from "./TheRekionAdminMenuHeader.vue?vue&type=script&lang=ts"
export * from "./TheRekionAdminMenuHeader.vue?vue&type=script&lang=ts"

import "./TheRekionAdminMenuHeader.vue?vue&type=style&index=0&id=1f7e907c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7e907c"]])

export default __exports__